import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface QueryAddLiquidacion {
  oid: number;
  consumidorFinal: false;
  tipo: string;
  observaciones: string;
  cliente: string;
  rutCliente: string | null;
  fechaInicio: string;
  rutDespachante?: string;
  despachante?: string;
}

export const addLiquidacion = async (
  query: QueryAddLiquidacion
): Promise<number> => {
  try {
    const res = await apiClient.post<ApiResponse<number>>(
      Endpoints.saveAndAddSettlement,
      {
        oid: query.oid,
        consumidorFinal: false,
        tipo: query.tipo,
        observaciones: query.observaciones,
        cliente: query.cliente,
        rutCliente: query.rutCliente,
        fechaInicio: query.fechaInicio,
        rutDespachante: query.rutDespachante,
        despachante: query.despachante,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
